// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__j2_d4","ranges":"BmiRanges_ranges__1qEVV"};